import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, ViewChild, TemplateRef, OnChanges} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import {DemoService} from '../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Location} from '@angular/common';
// Notifications
// import { HotToastService } from '@ngneat/hot-toast';
import { DatePipe } from '@angular/common';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { Observable, map, of } from 'rxjs'; // this created errors ats use below
// import {Observable} from 'rxjs/Rx';


// Using Loadash in Angular
// ::@ https://edupala.com/how-to-use-lodash-in-angular/
import * as _ from 'lodash';




import { MysqlService } from './../../../services/mysql.service';
import { Brand } from '../../../shared/models/brand.model';
import {SubjectTemplateDocs} from '../../../shared/models/subjectTemplateDocsModel.model';

import { FormsModule, Validators } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { ToolbarService, LinkService, ImageService, HtmlEditorService } from '@syncfusion/ej2-angular-richtexteditor';
import {
  RichTextEditorComponent,
  NodeSelection
} from '@syncfusion/ej2-angular-richtexteditor';

import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { HotToastService } from '@ngneat/hot-toast';
import { UploadDocxTemplateModalComponent } from '../../communication-manager/upload-docx-template-modal/upload-docx-template-modal.component';
import { UploadDocxThemeTemplateComponent } from '../../communication-manager/upload-docx-theme-template/upload-docx-theme-template.component';
import { UploadDotTemplateModalComponent } from '../../communication-manager/upload-dot-template-modal/upload-dot-template-modal.component';
import { UploadEmailTemplateModalComponent } from '../../communication-manager/upload-email-template-modal/upload-email-template-modal.component';
import { SystemAutomation } from 'src/app/shared/models/systemAutomation.model';
// import { SystemLogTypeDataSector } from 'src/app/shared/models/systemLogTypeDataSector.model';
import { SubjectServiceOutcomeTemplate } from 'src/app/shared/models/subjectServiceOutcomeTemplate.model';

@Component({
  selector: 'app-subject-service-outcome-template',
  templateUrl: './subject-service-outcome-template.component.html',
  styleUrls: ['./subject-service-outcome-template.component.scss']
})
export class SubjectServiceOutcomeTemplateComponent implements OnInit {



   // setup as observable?
   @Input() item_id?; // impliments on changes.
   @Input() item_data?; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '5'; // default to agent just in case
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size?; // side | abstract | full
  @Input() current_field_name?;

  all_router_details: string;
  system_automation_id: number;
  nav: any;
  system_automation: any;
  brand_types: Object;
  subject_com_types: Object;
  job_types: Object;
  system_log_type_automation_triggers: Object;
  system_log_type: Object;
  system_log_type_data_sectors: Object;
  array_of_triggers: any;
  system_subject_template_docs_automations: any;
  system_subject_template_docs_automations_commuications: any;
  system_log_type_data_sector_conditions: any;
  allFileAutomations: any;
  allCommunicationsAutomations: any;
  allConditionsAutomations: any;
 
 
  // model: SystemLogTypeDataSector;
  model: SubjectServiceOutcomeTemplate;


  log_type_data_sector_id: number;
  system_log_type_data_sector: any;

  isShow_condition_array = false;
  isShow_condition_array_example = false;
  isShow_condition_array_keys_example = false;
  isShow_condition_array_fields = false;
  isShow_database = false;
  isShow_database_model_angular = false;
  isShow_database_mysql = false;
  ssot_id: number;
  subject_services_outcome_templates: Object;
  condition_compare_result: boolean;
  true_count: any;
  false_count: any;
  load_ssoit: number;
  load_ssot_id: number;



  constructor(
    private _mysqlService: MysqlService,
    private route: ActivatedRoute,
      private router: Router,
      private http: HttpClient,
      private _demoService: DemoService,
      vcr: ViewContainerRef,
      private modalService: BsModalService,
      private _location: Location,
      public gfunc: GlobalFunctionsService,
      public toastr: HotToastService,
      private sanitizer: DomSanitizer
  ) {
    this.nav = document.querySelector('nav.navbar');
    // this.toastr.setRootViewContainerRef(vcr);

       // need to add this as routes does not work globally
       this.all_router_details = this.router.url;
       this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

    // this.system_automation_id = +this.route.snapshot.paramMap.get('system_automation_id');
    this.log_type_data_sector_id = +this.route.snapshot.paramMap.get('log_type_data_sector_id');
    this.ssot_id = +this.route.snapshot.paramMap.get('ssot_id');

   }



 // check for changes. to load data.
 ngOnChanges(changes): void  {
 
  this.model = new SubjectServiceOutcomeTemplate()
  // this.getSubjectServiceOutcomeTemplate(this.item_id);
 
  if (changes.widget_size) {
  this.widget_size = changes.widget_size.currentValue;
      if (this.widget_size == 'condition'){
      this.isShow_condition_array_example = true;
      }
    }

  if (changes.item_id) {
    // deal with asynchronous Observable result
    this.ssot_id = changes.item_id.currentValue;
   //  this.getBrandById(this.brand_id);
  //  this.baseUploadURL = this.gfunc.baseUploadURL_UserAssets + '/' + this.user_id; // no trailing slash
  //  this.getSystemAutomation(this.system_automation_id);
  // this.getSystemLogTypeDataSector(this.log_type_data_sector_id);
  this.getSubjectServiceOutcomeTemplate(this.ssot_id);



  this.getBrandTypes();
  this.getSubjectComTypes();
  this.getJobTypes();
    // this.getBrandUser(this.gfunc.sessionUserId);
    // this.getFormUserLevels();
    // this.getBrands();
  }

}


  ngOnInit(): void {

    this.model = new SubjectServiceOutcomeTemplate()
    if(this.widget_size == '' || !this.widget_size || this.widget_size == null){
    this.widget_size = 'full'
    }
    //  this.getSystemAutomation(this.system_automation_id);
  //  this.getSystemLogTypeDataSector(this.log_type_data_sector_id);

   this.getSubjectServiceOutcomeTemplate(this.ssot_id);

   this.getBrandTypes();
   this.getSubjectComTypes();
   this.getJobTypes();



  //  let new_model = {
  //   system_automation_array: this.allAutomations
  // }
  // this.getSystemAutomationsArray(new_model);

        //   // Send the single ID as an array.
        // let new_model = {
        //   system_automation_array: '["' + this.system_automation_id + '"]'
        // }
        // this.getSystemAutomationLogTypeTriggersByArray(new_model);
   
  }

  private getSystemAutomation(system_automation_id) {
    this._demoService.getSystemAutomation(system_automation_id)
      .subscribe(
        res => {
          this.system_automation = res;
          let data = res[0]


          this.allFileAutomations = JSON.parse(this.system_automation[0].system_file_array);
          this.allCommunicationsAutomations = JSON.parse(this.system_automation[0].system_communication_array);
          this.allConditionsAutomations = JSON.parse(this.system_automation[0].system_conditions_array);

          let new_model = {
            system_file_array: JSON.parse(this.system_automation[0].system_file_array)
          }
          this.getSystemSubjectTemplateDocsArray(new_model);

          let new_model_b = {
            system_communication_array: JSON.parse(this.system_automation[0].system_communication_array)
          }
          this.getSystemSubjectTemplateDocsArray_Communications(new_model_b);

          
          let new_model_c = {
            system_conditions_array: JSON.parse(this.system_automation[0].system_conditions_array)
          }
          this.getSystemSubjectTemplateDocsArray_Conditions(new_model_c);



          // this.getSystemLogType(data.system_log_type_id);
        },
        err => console.error(err.status)
      );
  }


  getBrandTypes() {
    this._demoService.getBrandBrandTypes().subscribe(
       data => { this.brand_types = data; },
       err => console.error(err),
       // () => console.log('done loading candidate for update')
     );
   }
  


   private getSubjectServiceOutcomeTemplate(ssot_id) {
    this._demoService.getSubjectServiceOutcomeTemplate(ssot_id)
      .subscribe(
        res => {
          this.system_log_type_data_sector = res;
          let data = res[0]


              // this.allFileAutomations = JSON.parse(this.system_automation[0].system_file_array);
              // this.allCommunicationsAutomations = JSON.parse(this.system_automation[0].system_communication_array);
              // this.allConditionsAutomations = JSON.parse(this.system_automation[0].system_conditions_array);

              // let new_model = {
              //   system_file_array: JSON.parse(this.system_automation[0].system_file_array)
              // }
              // this.getSystemSubjectTemplateDocsArray(new_model);

              // let new_model_b = {
              //   system_communication_array: JSON.parse(this.system_automation[0].system_communication_array)
              // }
              // this.getSystemSubjectTemplateDocsArray_Communications(new_model_b);

              
              // let new_model_c = {
              //   system_conditions_array: JSON.parse(this.system_automation[0].system_conditions_array)
              // }
              // this.getSystemSubjectTemplateDocsArray_Conditions(new_model_c);

  // Load all condition arrays from the subject_service_outcome_templates datatable (ssot_condition_arrays.)
 
//  // Load all the conditions
//   this.getSubjectServicesOutcomeTemplates(data)

          // this.getSystemLogType(data.system_log_type_id);
        },
        err => console.error(err.status)
      );
  }




  private getSystemLogTypeDataSector(log_type_data_sector_id) {
    this._demoService.getSystemLogTypeDataSector(log_type_data_sector_id)
      .subscribe(
        res => {
          this.system_log_type_data_sector = res;
          let data = res[0]


              // this.allFileAutomations = JSON.parse(this.system_automation[0].system_file_array);
              // this.allCommunicationsAutomations = JSON.parse(this.system_automation[0].system_communication_array);
              // this.allConditionsAutomations = JSON.parse(this.system_automation[0].system_conditions_array);

              // let new_model = {
              //   system_file_array: JSON.parse(this.system_automation[0].system_file_array)
              // }
              // this.getSystemSubjectTemplateDocsArray(new_model);

              // let new_model_b = {
              //   system_communication_array: JSON.parse(this.system_automation[0].system_communication_array)
              // }
              // this.getSystemSubjectTemplateDocsArray_Communications(new_model_b);

              
              // let new_model_c = {
              //   system_conditions_array: JSON.parse(this.system_automation[0].system_conditions_array)
              // }
              // this.getSystemSubjectTemplateDocsArray_Conditions(new_model_c);



          // this.getSystemLogType(data.system_log_type_id);
        },
        err => console.error(err.status)
      );
  }

   
   private getSubjectComTypes() {
    this._demoService.getSubjectComTypes()
      .subscribe(
        res => this.subject_com_types = res,
        err => console.error(err.status)
      );
  }

  getJobTypes() {
    this._demoService.getJobTypes().subscribe(
       data => { this.job_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }




  // This needs to send the Automation ID and return LOG TYPES it exists in.
  
  getSystemAutomationLogTypeTriggersByArray(request_array) {
    this._demoService.getSystemAutomationLogTypeTriggersByArray(request_array).subscribe(
       data => { this.system_log_type_automation_triggers = data;
        let res = data[0];
  
        // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
        // // console.log(this.arrCase);
        // this.Items = data['Items'] ;
        // this.sent_data = this.Items;
        // this.sent_data = this.myob_account_codes;



        // I need to do a loop of the entire array not just a single.
        // Then push the logtypeid and names to an new array. - show display array only.

// An array of objects
      // var persons = [{name: "Harry"}, {name: "Alice"}, {name: "Peter"}];
      // var logs_type_triggers = JSON.parse(data[5].system_automation_array);
      // console.log('AutomationArray: ' + logs_type_triggers)
      // if(logs_type_triggers.some(person => person == this.system_automation_id )){
      //   alert("Object found inside the array.");
      // } else{
      //   alert("Object not found.");
      // }



      // Working function to filter and create an array Log Type Items - Triggers Exists in .. (system_automations_array)
this.array_of_triggers = [];
 // Count items of brand search to loop through
 let  count_of_trigger_items = Object.keys(this.system_log_type_automation_triggers).length;
 // now loop and push to join model
 for(let i=0;i < count_of_trigger_items; i++) {
   let res2 = this.system_log_type_automation_triggers[i];
   var logs_type_triggers = JSON.parse(data[i].system_automation_array);
     // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
     if(logs_type_triggers.some(person => person == this.system_automation_id )){

     this.array_of_triggers.push({
    log_type_name: res2.log_type_name,
    log_type_id: res2.log_type_id,
             });

            } // end if exists in the current row array
 
 } // end brands loop.
 
 this.array_of_triggers = this.array_of_triggers;





// Find if the array contains an object by comparing the property value
// if(persons.some(person => person.name === "Peter")){
//     alert("Object found inside the array.");
// } else{
//     alert("Object not found.");
// }


  
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


  // ::@https://stackblitz.com/edit/angular-bmxbmy?file=src%2Fapp%2Fapp.component.html
  getHtml(html){
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  groupResolutionOutcomesByType(outcomes: any): any[] {
    const grouped = [];
    Object(outcomes || []).forEach((outcome) => {
      const typeId = Number(outcome.subject_service_resolution_outcome_type_id || 0);
      const typeName = outcome.subject_service_resolution_outcome_type_name || 'Unassigned';
      const typeActive = outcome.subject_service_resolution_outcome_type_is_active;
      if (typeActive != null && typeActive !== 1 && typeActive !== '1' && typeActive !== true && typeActive !== 'Y') {
        return;
      }
      let group = grouped.find(item => item.type_id === typeId);
      if (!group) {
        group = { type_id: typeId, type_name: typeName, outcomes: [] };
        grouped.push(group);
      }
      group.outcomes.push(outcome);
    });
    return grouped;
  }

    // ::@https://stackoverflow.com/questions/29369512/render-html-entities-string-in-html-with-angular properway to do it (decode html special charactors for dispaly)
  // WORKS as I created my own function from this articel == pretty well convers
  transform2(value: any, args?: any): any {
    const doc = new DOMParser().parseFromString(value, 'text/html');
    return doc.documentElement.textContent;
  }




   getSystemLogType(log_type_id) {
    this._demoService.getSystemLogType(log_type_id).subscribe(
       data => { this.system_log_type = data;
  
        let res = data[0]
        // this.allRecipients = JSON.parse(this.system_log_type[0].system_automation_array);
        // this.allAutomations = JSON.parse(this.system_log_type[0].system_automation_array);
        // Lookup the Automations

  
      
      },
       err => console.error(err),
       () => console.log('System Log Type')
     );
   }
  
  
   getSystemLogTypeDataSectors() {
    this._demoService.getSystemLogTypeDataSectors().subscribe(
       data => { this.system_log_type_data_sectors = data;
      
      },
       err => console.error(err),
       () => console.log('System Log Type')
     );
   }
  


   getSystemSubjectTemplateDocsArray(request_array) {
    this._demoService.getSystemSubjectTemplateDocsArray(request_array).subscribe(
       data => { this.system_subject_template_docs_automations = data;
        let res = data[0];
  
        // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
        // // console.log(this.arrCase);
        // this.Items = data['Items'] ;
        // this.sent_data = this.Items;
        // this.sent_data = this.myob_account_codes;
  
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
  
   getSystemSubjectTemplateDocsArray_Communications(request_array) {
    this._demoService.getSystemSubjectTemplateDocsArray_Communications(request_array).subscribe(
       data => { this.system_subject_template_docs_automations_commuications = data;
        let res = data[0];
  
        // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
        // // console.log(this.arrCase);
        // this.Items = data['Items'] ;
        // this.sent_data = this.Items;
        // this.sent_data = this.myob_account_codes;
  
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
  
  
   getSystemSubjectTemplateDocsArray_Conditions(request_array) {
    this._demoService.getSystemSubjectTemplateDocsArray_Conditions(request_array).subscribe(
       data => { this.system_log_type_data_sector_conditions = data;
        let res = data[0];
  
        // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
        // // console.log(this.arrCase);
        // this.Items = data['Items'] ;
        // this.sent_data = this.Items;
        // this.sent_data = this.myob_account_codes;
  
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  


   // UPDATE THIS FROM SERVICES.component as it now renders and does all the merge variables as well

LoadSubjectserviceOutcomeTemplateParagraph(model){

  console.log(JSON.stringify(model));
  
let model2 = model;
/*
 "subject_attempt_type_id": "2",
  "subject_service_outcome_id": "14",
  "attempts": "Attempts are continuing."
*/
console.log('model.subject_attempt_type_id: ' + model.attempts)
console.log('model.subject_attempt_type_id: ' + model2.subject_attempt_type_id )
// model2 = model2
// Outcome 1  Attempt, subject Did not appear, attempts, contunueing.
  if(
    model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '14' && model2.attempts == "Attempts are continuing."
    ){
      this.load_ssot_id = 1 
      this.getSubjectServiceOutcomeTemplate(1);
      console.log('Outcome 1');
    } // determine which template to load



    
  let load_ssot_id = 1

}



   getSubjectServicesOutcomeTemplates(model){
    this._demoService.getSubjectServicesOutcomeTemplates().subscribe(
      data55 => { 
        
        this.subject_services_outcome_templates = data55;
      

        // Lets to a contidioon check...

        let condition_array = JSON.parse(data55[0].ssot_condition_array) // condition array set the templates.
        console.log('Condition Array to Check - Conditions: ', condition_array)

        let current_log_content = JSON.stringify(model);
        
        // let passed_current_log_content = JSON.parse(log_model[0].log_content))
        

              // Filters objects for nul and undefined values.
              // const obj = current_log_content;
              // const filteredObject = _.pickBy(obj, v => v !== null && v !== undefined);
              // console.log = (obj) => document.write(JSON.stringify(filteredObject, null, 2));
              // console.log('FilteredObject', JSON.stringify(filteredObject));

                // let string_array = {"subject_id":"701","job_id":"1200","first_name": "r"}; // base condition_array - for comparison.
               
               
               
                // let string_array = JSON.parse(data55[0].condition_array); // base condition_array - for comparison.
             
             
                let string_array = JSON.parse(data55[0].ssot_condition_array); // base condition_array - for comparison.
                let d: (string | any)[] = [string_array]


              // let a = JSON.parse(model); // current passed model
              let a = JSON.stringify(model); // current passed model
              // let a = model; // current passed model
              let b = condition_array;
                let kv = [a];
                const l = new Set(Object.keys(string_array));
                console.log('ObjectKeys Condition Array: ', Object.keys(string_array));
                // #2 :: Filter throught A : the_log_content and remove anything not esisting int the log_content  array. [kv]
                for (let obj of kv) {
                  for (let prop of Object.keys(obj)) {
                    if (!l.has(prop)) {
                        delete obj[prop];
                    }
                  }
                }
                console.log('Whats Left KV: ', kv);
                console.log('Condition Array to Compare log Content: ', kv)
               let compare_result = _.isEqual(_.sortBy(kv), _.sortBy(d))
              //  console.log('Condition ', z + ' ' + compare_result);
            
              
               if(compare_result == true){
                // return false;
                this.condition_compare_result = true;
                this.true_count = this.true_count + 1
                return;
                }else if(compare_result == false) {
                this.condition_compare_result = false;
                this.false_count = this.false_count + 1
                return;
                }
      
      
      },
      err => console.error(err),
       () => {
         console.log('done loading Subject Services Outome Templates');
        // this.collection = Array (this.job_types, this.job_type_locations); // collection of all data
        // let mappedJSON = JSON.parse(mapped);
        // console.log('Mapped JSON Array: ' + mappedJSON);
       }
         );
   }
  






}
